/**
 * Encodes a string to base64url.
 *
 * @param str - The string to encode as an ArrayBuffer.
 * @returns The base64url encoded string.
 */
export const encodeBase64Url = (str: ArrayBuffer) => {
  const numberArray: number[] = [];
  new Uint8Array(str).forEach((item) => numberArray.push(item));

  // Deprecated btoa used for web compatibility
  return btoa(String.fromCharCode.apply(null, numberArray))
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
};
